import { css, Theme } from '@emotion/react'

export const divider = (theme: Theme) => css`
  margin-top: ${theme.spacing(3.75)};
  margin-bottom: ${theme.spacing(3.75)};
`

export const tabs = (theme: Theme) => css`
  margin: ${theme.spacing(3, 0, 3)};
`
